import app from 'flarum/forum/app';

app.initializers.add('foghour/helpers', () => {

});

// Expose compat API
import customCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, customCompat);
